import { Firestore } from "lib/firebase";

export const save = async (customer) => {
    const { id, ...data } = customer;
    try {
        await Firestore.collection("users")
            .doc(id)
            .set(data, { merge: true });
    } catch (error) {
        console.log(error);
    }
}

export const saveHistory = async (customer, history, user) => {

    if (Object.keys(history).length === 0) {
        return;
    }

    const data = {
        changes: { ...history },
        timestamp: +new Date(),
        user: user.ref
    };

    try {
        await Firestore.collection("users")
            .doc(customer.id)
            .collection('history')
            .add(data);
    } catch (error) {
        console.log(error);
    }
}
